<!-- src/components/Home.vue -->
<template>
  <div class="header">
    <img class="hdimgs" src="https://fxhoss.chinalaw.org.cn/img/headerinfo.96e12701.png" alt="" />
    <div class="headertabs_box">
      <div class="headertabs">
        <ul class="munu_ul">
          <li class="indextab tabs" @click="toindex()">首页</li>
          <li class="tabs"  v-for="(item, index) in catelist" :key="index">
            <span @click="tolist(item.id)"> {{ item.name }}</span>
            <ul class="child" v-if="item.child && item.id != 86">
              <li class="tabs_c" v-for="(chi, c) in item.child" :key="c" @click="tolist(chi.id)">{{ chi.name }}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {},
  data() {
    return {
      // tablist: this.$store.state.catelist
    };
  },
  computed: {
    catelist() {
      return this.$store.state.catelist;
    }
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    getcatelist() {
      this.catelist = this.$store.state.catelist;
    },
    toindex() {
      this.$router.push({ path: "/" });
    },
    goAnchor(id) {
      document.querySelector("#" + id).scrollIntoView({ behavior: "smooth" });
    },
    tolist(id) {
      if (id == 86) {
        if (this.$route.name != "index") {
          this.$router.push({ name: "index", query: { jump: "lingdao" } });
          return;
        }
        this.goAnchor("lingdao");
        return;
      }
      this.$router.push({ name: "list", query: { categoryid: id } });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
@media all and (max-width: 800px) {
  .header {
    width: 100% !important;
    height: 238px !important;
    .hdimgs {
      margin-top: 54px !important;
      width: 396px !important;
      max-width: 100% !important;
    }
    .headertabs_box {
      width: 100% !important;
      height: 30px !important;
      margin-top: 44px !important;
    }

    .headertabs {
      width: 100% !important;
      height: 30px !important;
      margin: 0 auto !important;
      padding: 0 5px !important;
      box-sizing: border-box !important;
      .child {
        width: 45px !important;
        left: 0px !important;
        top: 20px !important;
        padding-top: 0px !important;
        .tabs_c {
          height: 20px !important;
        }
      }
      .tabs {
        font-size: 7px !important;
      }
    }
  }
}
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  // max-width: 2000px;
  background: url("https://fxhoss.chinalaw.org.cn/img/headerbg.ea745a01.png") no-repeat;
  background-size: 100% 100%;
  .hdimgs {
    margin-top: 43px;
    width: 900px;
  }
  .headertabs_box {
    margin-top: 35px;
    z-index: 999999 !important;
    width: 1170px;
    height: 60px;
    box-sizing: border-box;
    padding: 2px;
    border-radius: 30px;
    background-image: -webkit-linear-gradient(90deg, #ffca51, #ffca51);
  }

  .headertabs {
    margin: 0 auto;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    background: #c50909;
    border-radius: 30px;
    color: #fff;
    padding-right: 30px;
    box-sizing: border-box;
    z-index: 999999 !important;

    .munu_ul {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      list-style-type: disc;
      margin-block-start: 0em;
      margin-block-end: 0em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 0px;
      unicode-bidi: isolate;
      li {
        list-style: none;
        position: relative;
      }
    }
    .tabs:hover {
      color: #ffca51 !important;
    }

    .tabs:hover .child {
      display: block;
    }

    .child {
      width: 115px;
      background-color: #c50709;
      display: block;
      display: none;
      position: absolute;
      left: 5px;
      top: 22px;
      padding-top: 20px;
      margin-block-start: 0em;
      margin-block-end: 0em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 0px;
      li {
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
      }
      li:hover {
        color: #ffca51 !important;
      }
    }

    .indextab {
      border: none !important;
    }
    .tabs {
      flex: 1;
      text-align: center;
      border-left: 1px solid #ffca51;
      box-sizing: border-box;
      font-size: 18px;
      cursor: pointer;
    }
  }
}
</style>
